import { BaseEnvironment } from './baseEnvironment.interface';
export const baseEnvironmentProd: BaseEnvironment = {
  production: true,

  authenticationUrl: 'https://auth.datalean-nodejs.catalean.com/',
  usersUrl: 'https://user.datalean-nodejs.catalean.com/user/',
  surveyUrl: 'https://survey.datalean-nodejs.catalean.com/survey/',
  surveyResponseUrl: 'https://survey.datalean-nodejs.catalean.com/response/',
  groupsUrl: 'https://user.datalean-nodejs.catalean.com/user/applicationGroup/',
  smartGroupsUrl: 'https://user.datalean-nodejs.catalean.com/user/applicationSmartGroup/',
  contestUrl: 'https://contest.datalean-nodejs.catalean.com/contest/',
  tableUsersUrl: 'https://user.datalean-nodejs.catalean.com/user/smartcommunity/',
  applicationUsersUrl: 'https://user.datalean-nodejs.catalean.com/user/application/',
  productUrl: 'https://core-entities.datalean-nodejs.catalean.com/product/',
  communicationUrl: 'https://core-entities.datalean-nodejs.catalean.com/communication/',
  communityUrl: 'https://community.datalean-nodejs.catalean.com/community/',
  mediaLibraryUrl: 'https://media-library.datalean-nodejs.catalean.com/media-library/',
  structureUrl: 'https://structure.datalean-nodejs.catalean.com/structure/',
  structureFieldUrl: 'https://structure.datalean-nodejs.catalean.com/structureField/',
  filterUrl: 'https://filter.datalean-nodejs.catalean.com/filter/',
  featureValueUrl: 'https://feature.datalean-nodejs.catalean.com/featureValue/',
  organizationUrl: 'https://organization.datalean-nodejs.catalean.com/organization/',
  configurationUrl: 'https://configuration.datalean-nodejs.catalean.com/config/',
  rolesUrl: ' https://user.datalean-nodejs.catalean.com/role/',
  permissionUrl: ' https://user.datalean-nodejs.catalean.com/permission/',
  userStructureUrl: 'https://structure.datalean-nodejs.catalean.com/userstructure/',
  wishlistUrl: 'https://core-entities.datalean-nodejs.catalean.com/wishlist/',
  templateUrl: 'https://translator.datalean-nodejs.catalean.com/template',
  integrationUrl: 'https://configuration.datalean-nodejs.catalean.com/integration/',
  contentUrl: 'https://core-entities.datalean-nodejs.catalean.com/content/',
  // filterUrl: 'https://filter.datalean-nodejs.catalean.com/filter/',
  resourceUrl: 'https://reservation.datalean-nodejs.catalean.com/resource/',
  availabilityRuleUrl: 'https://reservation.datalean-nodejs.catalean.com/availability-rule/',
  bookableProductUrl: 'https://reservation.datalean-nodejs.catalean.com/product/',
  reservationsUrl: 'https://reservation.datalean-nodejs.catalean.com/reservation/',
  lessonUrl: 'https://lms.datalean-nodejs.catalean.com/lesson/',
  orderUrl: 'https://dataleandev.catalean.com/order/',
  gstorageUrl: 'https://dataleandev.catalean.com/gstorage/',
  feedbackUrl: 'https://datalean.catalean.com/generalfeedback/feedback/',
  bookableResourceUrl: 'https://dataleandev.catalean.com/booking/',
  changelogUrl: 'https://dataleandev.catalean.com/changelog/',
  entityChangelogUrl: 'https://dataleandev.catalean.com/entityChangelog/',

  privacyUrl: 'https://addiction.it/privacy-policy/',
  conditionTermUrl: 'https://addiction.it/privacy-policy/',
  tableStructureUUID: '',
  cataleanUrl: '',
  orgLogoUrl: '',

  version: '2.2.6',
};
